angular.module('bribac.services.filterUtils', [])

.factory('filterUtils', function () {
    return {
        filterDevices: function (currFilter, data) {
            return doFilter(currFilter, data, 'ibac');
        },
        filterOrganizations: function (currFilter, data) {
            return filterByName(doFilter(currFilter, data, 'organization'));
        }
    };
  });

  function filterByName(data) {
    if (!data) {
        return
    }
    var filteredData = data;
    filteredData.sort(function (a, b) {
        var lca = a.name.toLowerCase();
        var lcb = b.name.toLowerCase();
        if (lca < lcb) {
            return -1;
        } else if (lca > lcb) {
            return 1;
        } else {
            return 0;
        }
    });

    return filteredData;
  }

  function doFilter(currentFilter, data, entityType) {
    if (!data) {
        return
    }
    var filteredData;
    switch (currentFilter) {
        case 'active':
            filteredData = data.filter(function (item) {
                return getStatusByType(item, entityType, true);
            });
            break;
        case 'inactive':
            filteredData = data.filter(function (item) {
                return getStatusByType(item, entityType, false)
            });
            break;
        case 'tampered':
            filteredData = data.filter(function (item) {
                return getStatusByType(item, entityType, false, true)
            });
            break;
        default:
            filteredData = data
    }
    filteredData.sort(function (a, b) {
        return (a.id - b.id)
    });

    return filteredData;
}

function getStatusByType(item, type, activeStatus, tampered) {
    switch (type) {
        case 'ibac':
            var byActiveStatus = activeStatus ? !item.isLocked : item.isLocked;
            if (tampered) {
                return !activeStatus && item.isTampered
            }
            return byActiveStatus;
        case 'organization':
            return activeStatus ? item.isActive : !item.isActive;
        default:
            return true
    }
}
